import Component from "./CourseFeed";
export default Component;
